import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Button from 'components/form/Button';
import CheckBox from 'components/form/CheckBox';
import { icons } from 'utils/constants';
import { sendHallTicketPreference, showSuccess } from 'store/slices';
import { downloadFile, objectToFormData } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

const Receipt = ({
  abstractDetails,
  setOpenPreviewPopup,
  type,
  setOpenHallTicketPopup,
}) => {
  const isReceipt = type === 'Receipt';
  const initialValues = {
    preferences: {
      whatsapp: false,
      email: false,
    },
  };

  const validationSchema = Yup.object().shape({
    preferences: Yup.object()
      .shape({
        whatsapp: Yup.boolean(),
        email: Yup.boolean(),
      })
      .test(
        'at-least-one',
        'At least one option (WhatsApp or Email) must be selected.',
        (value) => value?.whatsapp || value?.email
      ),
  });

  const dispatch = useDispatch();
  const handleSubmit = async (values, { setSubmitting }) => {
    const { preferences } = values;
    const sendVia = Object.keys(preferences)
      .filter((key) => preferences[key]) // only keep true ones
      .join(',');
    const payload = {
      type: 'abstract',
      id: abstractDetails?.abstract_id,
      send_via: sendVia,
      sending_type: type,
    };

    const response = await dispatch(
      sendHallTicketPreference(objectToFormData(payload))
    );
    if (response.status === 200) {
      dispatch(showSuccess(response.message));
    }

    setSubmitting(false);
  };

  const handlePrintPDF = async (pdfUrl) => {
    try {
      const response = await axios.get(pdfUrl, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;

      document.body.appendChild(iframe);

      iframe.onload = function () {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };
    } catch (error) {
      console.error('Error fetching or printing PDF:', error);
    }
  };

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const {
    view: viewAccess,
    create: createAccess,
  } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'Instant Ticket Generate'
    )?.sub_permission || {};

  return (
    <div className="other-detail">
      <h5>{isReceipt ? 'Receipt' : 'Hall Ticket'}</h5>

      {!abstractDetails?.is_payment_section_visible ||
        !abstractDetails.hall_ticket_url ? (
        <div className="flex flex-col items-center justify-center text-center">
          <div className="mb-3">
            <img src={icons.circleInfo} height={24} width={24} alt="Info" />
          </div>
          <div className="text-20-400-25 mb-5">
            {isReceipt ? 'Receipt' : 'Hall Ticket'} Not Available
          </div>
        </div>
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, isSubmitting }) => (
            <Form>
              <div className="row">
                {/* Pass Send Via */}
                <div className="col-md-6">
                  <div className="justify-content-start">
                    <div className="text-14-400-18 cmb-14">Pass Send Via :</div>
                    <div className="d-flex gap-3">
                      <div className="d-flex align-items-center gap-2">
                        <CheckBox
                          type="ACTIVE"
                          isChecked={values.preferences.whatsapp}
                          onClick={() =>
                            setFieldValue(
                              'preferences.whatsapp',
                              !values.preferences.whatsapp
                            )
                          }
                        />
                        <span className="text-black-olive text-14-300-18">
                          Whats App
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <CheckBox
                          type="ACTIVE"
                          isChecked={values.preferences.email}
                          onClick={() =>
                            setFieldValue(
                              'preferences.email',
                              !values.preferences.email
                            )
                          }
                        />
                        <span className="text-black-olive text-14-300-18">
                          E-Mail
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Preview Button */}
                <div className="col-md-6">
                  <div className="text-14-400-18 cmb-14">
                    {isReceipt ? 'Receipt' : 'Hall Ticket'}:
                  </div>

                  {viewAccess === "1" &&
                    <button
                      className="preview-btn"
                      type="button"
                      onClick={() => {
                        if (isReceipt) {
                          setOpenPreviewPopup?.(true);
                        } else {
                          setOpenHallTicketPopup(true);
                        }
                      }}
                    >
                      <img src={icons.blueEyeIcon} alt="Preview" />
                      Preview {isReceipt ? 'Receipt' : 'Ticket'}
                    </button>}
{/* 
                  {abstractDetails?.is_account_side_payment === "1" && isReceipt &&
                    <button
                      className="preview-btn cmt-5"
                      type="button"
                      onClick={() =>
                        dispatch(downloadFile(abstractDetails?.previewInvoiceUrl))
                      }
                    >
                      <img src={icons.blueEyeIcon} alt="Preview" />
                      Preview payment proof
                    </button>
                  } */}
                </div>
              </div>

              {/* Validation Error */}
              {errors.preferences && typeof errors.preferences === 'string' && (
                <div className="text-danger text-12-400-18 mt-2">
                  {errors.preferences}
                </div>
              )}

              {/* Buttons */}
              {createAccess === '1' && (
                <div className="d-flex align-items-center gap-2 cmb-20">
                  <Button
                    text="Send"
                    btnStyle="primary-dark"
                    className="h-35 cps-20 cpe-20 mt-3"
                    type="submit"
                    btnLoading={isSubmitting}
                    disabled={isSubmitting}
                  />
                  {!isReceipt && (
                    <Button
                      text="Print"
                      btnStyle="primary-outline"
                      className="h-35 cps-20 cpe-20 mt-3"
                      disabled={isSubmitting}
                      onClick={() =>
                        handlePrintPDF(abstractDetails.hall_ticket_url)
                      }
                    />
                  )}
                </div>
              )}
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default Receipt;
